// gatsby-browser.jsx
import * as React from "react";
import "./src/css/styles.css";

export const wrapRootElement = ({ element }) => <div>{element}</div>;
